import { authGuard } from '@auth0/auth0-vue';
import { RouteNames } from '@/data/routes';
import { createRoutes } from '@/utils/router-helper';

import financingRoutes from '@/routes/financing.routes';

import MCAVendorListPage from '@/pages/mca/MCAVendorListPage.vue';
import MCASubpageClearbancCardPage from '@/pages/mca/MCASubpageClearbancCardPage.vue';
import MCAPaymentsPage from '@/pages/mca/MCAPaymentsPage.vue';
import MCASpendTransactionsPage from '@/pages/mca/MCASpendTransactionsPage.vue';

export default createRoutes({
  path: '/mca',
  beforeEnter: authGuard,
  meta: {
    displayNav: true,
    isLegacy: true,
  },
  children: [
    {
      path: '', // MCA Route
      alias: '/vendor-list',
      name: RouteNames.MCA.VENDOR_LIST,
      component: MCAVendorListPage,
    },
    {
      path: 'clearco-card', // MCA Route - Should Remove?
      alias: '/clearco-card',
      name: RouteNames.MCA.CLEARCO_CARD,
      component: MCASubpageClearbancCardPage,
    },
    {
      path: 'payments', // MCA Route
      name: RouteNames.MCA.PAYMENTS,
      component: MCAPaymentsPage,
      meta: {
        requiresAuth: true,
        segment: [
          'core',
          'self_serve',
          'extend_runway',
          'mrr_factoring',
          'bnpl',
        ],
      },
    },
    {
      path: 'spend-transactions', // MCA Route
      alias: '/spend-transactions',
      name: RouteNames.MCA.SPEND_TRANSACTIONS,
      component: MCASpendTransactionsPage,
      meta: {
        requiresAuth: true,
        segment: [
          'core',
          'self_serve',
          'extend_runway',
          'mrr_factoring',
          'indiegogo',
          'bnpl',
        ],
      },
    },
    ...financingRoutes,
  ],
});
